import { Box, Chip, Text } from '@usealloy/component-library';
import styled from 'styled-components';

import { RebrandColors } from '~/constants';

export const YourCustomerItemContainer = styled(Box)`
  & {
    padding-top: var(--cl-space-5);
    border-top: 1px solid var(--cl-gray-500);

    &:first-child {
      padding-top: 0;
      border-top: none;
    }
  }
`;

const Service = styled(Box)`
  && {
    width: auto;
    padding: var(--cl-space-1) var(--cl-space-2);
    border-radius: var(--cl-radius-4);
  }
`;

export const ServiceMatched = styled(Service)`
  & {
    background: var(--cl-green-100);
  }
`;

export const ServiceUnmatched = styled(Service)`
  & {
    background: var(--cl-gray-300);
  }
`;

export const VelocityWarning = styled(Service)`
  & {
    background: var(--cl-orange-100);
  }
`;

export const NoChangeChip = styled(Chip)`
  && {
    margin: 0;
    padding: 6px var(--cl-space-1);
    font-size: var(--cl-font-size-2);
  }
`;

export const UpdatedValue = styled(Text)`
  max-width: 100%;

  .flex-col {
    min-height: var(--cl-space-6);
    min-width: 0;
    padding: 6px var(--cl-space-1);
    border-radius: var(--cl-radius-3);
    background-color: ${RebrandColors.YELLOW_100};
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    line-height: var(--cl-line-height-3);
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    display: inline-block;

    p {
      line-height: var(--cl-line-height-1);
    }
  }

  /* Keep copy icon visible when text wraps */
  .flex-col + span {
    flex-shrink: 0;
  }
`;

export const FormattedRecord = styled(Text)`
  > p {
    padding-right: var(--cl-space-2);
    display: inline-block;
  }

  /* Wrap unbroken strings (e.g. email) and keep copy icon visible */
  .flex-col {
    min-width: 0;
    overflow-wrap: break-word;
    padding: 6px var(--cl-space-1);
    word-break: break-word;
    white-space: normal;
  }

  .flex-col + span {
    flex-shrink: 0;
  }
`;
